import React, {useEffect, useState} from "react";
import {ProfileAdminHeader} from "../admin/ProfileAdminHeader";
import {ProfileNavigationAdmin} from "../admin/ProfileNavigationAdmin";
import SessionModel from "../../../stores/SessionModel";
import * as ChallengeAPI from "../../../requests/ChallengeAPI";
import { IXlsUnloadRequest } from "../../types/xls/IXlsUnloadRequest";
import {IChallengeSuggestion} from "../../types/challenge/IChallengeSuggestion";
import {response} from "express";


export const UnloadsAdmin = () => {

    const [unloadingUniversities, setUnloadingUniversities] = useState(false);
    const [unloadingStudents, setUnloadingStudents] = useState(false);
    const [unloadingBusiness, setUnloadingBusiness] = useState(false);
    const [unloadingMentors, setUnloadingMentors] = useState(false);
    const [unloadRequest, setUnloadRequest] = useState<IXlsUnloadRequest>();
    const [search, setSearch] = useState<string>();
    const [suggestions, setSuggestions] = useState<IChallengeSuggestion[]>([]);
    const [challengeList, setChallengeList] = useState<IChallengeSuggestion[]>([]);
    const [error, setError] = useState("");

    useEffect(() => {
        if (SessionModel.getCurrentUserAuthData().type !== "ADMIN" && !SessionModel.isModerator()) {
            localStorage.getItem("token");
            window.location.href = "/";
        } else {
            setUnloadRequest({...unloadRequest,
                username: SessionModel.getCurrentUserAuthData().sub, challengeIds: []})
        }
    }, []);

    useEffect(() => {
        if (!search) {
            setSuggestions([]);
            return;
        }
        ChallengeAPI.getChallengeSuggestions(search || "", (response) => {
            if (response.status === 200) {
                setSuggestions(response.data);
            }
        })
    }, [search]);

    const pickSuggestion = (s: IChallengeSuggestion) => {
        if (challengeList.filter(cl => cl.id === s.id).length > 0) return;
        const newChallengeList = challengeList;
        newChallengeList.push(s);
        setChallengeList(newChallengeList);
        const ids: number[] = [];
        newChallengeList.forEach(c => ids.push(c.id));
        setUnloadRequest({...unloadRequest, challengeIds: ids});
        setSuggestions([]);
        setSearch("");
    }

    const removeSuggestion = (id: number) => {
        const newChallengeList = challengeList.filter(c => c.id !== id);
        setChallengeList(newChallengeList);
        const ids: number[] = [];
        newChallengeList.forEach(c => ids.push(c.id));
        setUnloadRequest({...unloadRequest, challengeIds: ids});
        setSuggestions([]);
        setSearch("");
    }

    const unloadUniversities = () => {
        if (unloadingUniversities || !validateRequest())
            return;
        setUnloadingUniversities(true);
        ChallengeAPI.unloadUniversities(unloadRequest, (status) => {

            setUnloadingUniversities(false);
            if (status === 400) {
                setError("Неправильный пароль");
            }
        });
    }

    const unloadStudents = (visibleOnly: number) => {
        if (unloadingStudents || !validateRequest())
            return
        setUnloadingStudents(true);
        ChallengeAPI.unloadStudents(unloadRequest, visibleOnly,(status) => {
            setUnloadingStudents(false);
            if (status === 400) {
                setError("Неправильный пароль");
            }
        });
    }

    const unloadBusiness = () => {
        if (unloadingBusiness || !validateRequest())
            return;
        setUnloadingBusiness(true);
        ChallengeAPI.unloadBusiness(unloadRequest, (status) => {
            setUnloadingBusiness(false);
            if (status === 400) {
                setError("Неправильный пароль");
            }
        });
    }

    const unloadMentors = () => {
        if (unloadingMentors || !validateRequest())
            return;
        setUnloadingMentors(true);
        ChallengeAPI.unloadMentors(unloadRequest, (status) => {
            setUnloadingMentors(false);
            if (status === 400) {
                setError("Неправильный пароль");
            }
        });
    }

    const validateRequest = () : boolean => {
        if (!unloadRequest || !unloadRequest.fromDate || !unloadRequest.toDate) {
            setError("Заполните даты");
            return false;
        }
        setError("");
        return true;
    }

    return (
        <div className="platform-background">
            <img src="/images/main.jpg" className="image-back-video" alt=""/>
            <div className="left-block">
                <ProfileAdminHeader/>
                <main className="content">
                    <ProfileNavigationAdmin />
                    <div className="main-list-center">
                        <div className="my-challenge">
                            <div className="user-info">
                                <p className="fio-or-name">Выгрузки</p>
                            </div>
                        </div>
                        <ul className="challenge-info">

                            <p className="error-message" id="form-validation-error"
                               style={{display: error === "" ? "none" : "", cursor: "default"}}
                               dangerouslySetInnerHTML={{__html: error || ""}}></p>

                            <div className="filter_download-info">
                                <fieldset className="block-input">
                                    <legend className="legend">Даты</legend>
                                    <div className="filter_date">
                                        от
                                        <input type="date" value={unloadRequest?.fromDate}
                                               className="input-challenges"
                                               onChange={(e) => setUnloadRequest({...unloadRequest, fromDate: e.target.value})}/>
                                        до
                                        <input type="date" value={unloadRequest?.toDate} className="input-challenges"
                                               onChange={(e) => setUnloadRequest({...unloadRequest, toDate: e.target.value})}/>
                                    </div>
                                </fieldset>
                                <fieldset className="block-input">
                                    <legend className="legend">Соревнеование</legend>
                                    <input type="text" className="input-challenges city-search"
                                           value={search}
                                           onChange={(e) => setSearch(e.target.value)}
                                           placeholder="Введите название соревнования"/>
                                    <div className="container-city">
                                        {suggestions?.map((s, index) =>
                                            <div className="city-input" key={index} onClick={() => pickSuggestion(s)}>
                                                {s.name}
                                            </div>
                                        )}
                                    </div>
                                    <ul className="filter_dowload-list">
                                        {challengeList?.map((c, index) =>
                                            <li className="filter_dowload-item" key={index}>
                                                {c.name}
                                                <span className="filter_dowload-btn" onClick={() => removeSuggestion(c.id)}/>
                                            </li>
                                        )}
                                    </ul>
                                    {/*<div className="filter_radio-flex">
                                        <label className="radio_filter-dowload">
                                            <input type="radio" name="status" id="" className="radio-btn"/>
                                            <span className="span-radio">Все</span>
                                        </label>
                                        <label className="radio_filter-dowload">
                                            <input type="radio" name="status" id="" className="radio-btn"/>
                                            <span className="span-radio">Только студенты</span>
                                        </label>
                                        <label className="radio_filter-dowload">
                                            <input type="radio" name="status" id="" className="radio-btn"/>
                                            <span className="span-radio">Только профессионалы</span>
                                        </label>
                                    </div>
                                    <legend className="legend">Образовательное учреждение</legend>
                                    <input type="text" name="" id="" className="input-challenges city-search"
                                           placeholder="Начните вводить"/>
                                    <div className="container-city">
                                        <div className="city-input">
                                            Сбер технологии
                                        </div>
                                        <div className="city-input">
                                            Сбер технологии
                                        </div>
                                    </div>
                                    <ul className="filter_dowload-list">
                                        <li className="filter_dowload-item">
                                            МГМОУСУПБЕГОМ
                                            <span className="filter_dowload-btn"></span>
                                        </li>
                                        <li className="filter_dowload-item">
                                            ТТТиММыСПис
                                            <span className="filter_dowload-btn"></span>
                                        </li>
                                    </ul>*/}
                                    <input type="password" value={unloadRequest?.password} placeholder="Введите пароль"
                                           onChange={(e) => setUnloadRequest({
                                               ...unloadRequest,
                                               password: e.target.value
                                           })}
                                           className="input-challenges" style={{display: "inline-block"}}/>
                                    <li className="challenge-card" style={{display: "inline-block"}}>
                                        <button onClick={() => unloadUniversities()} className="challenge-activity"
                                                style={{marginRight: "10px"}}
                                                disabled={unloadingUniversities}>{unloadingUniversities ? "Выгружаются..." : "Выгрузить ВУЗЫ"}</button>
                                        <button onClick={() => unloadBusiness()} className="challenge-activity"
                                                style={{marginRight: "10px"}}
                                                disabled={unloadingBusiness}>{unloadingBusiness ? "Выгружаются..." : "Выгрузить организации"}</button>
                                        {SessionModel.isAdmin() ?
                                            <>
                                                <button onClick={() => unloadStudents(0)} className="challenge-activity"
                                                        disabled={unloadingStudents}>{unloadingStudents ? "Выгружаются..." : "Выгрузить студентов"}</button>
                                                <button onClick={() => unloadStudents(1)} className="challenge-activity"
                                                        disabled={unloadingStudents}>{unloadingStudents ? "Выгружаются..." : "Выгрузить студентов по ленточным"}</button>
                                                <button onClick={() => unloadMentors()} className="challenge-activity"
                                                        disabled={unloadingMentors}>{unloadingMentors ? "Выгружаются..." : "Выгрузить наставников"}</button>
                                            </> : <></>}
                                    </li>
                                </fieldset>
                            </div>
                        </ul>
                    </div>
                </main>
            </div>
        </div>
    );
}